<div>
  <div class="flex justify-end mb-4">
    <button
      class="py-1 px-5 border border-[#d9d9d9] rounded"
      (click)="onGroupRevert()"
      [disabled]="selectedSecurities.length < 2"
      [ngClass]="{
        'bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]':
          selectedSecurities.length >= 2,
        'bg-white text-gray-800 cursor-not-allowed': selectedSecurities.length < 2
      }"
      pTooltip="{{
        selectedSecurities.length < 2
          ? 'Select at least two rows to enable grouping'
          : ''
      }}"
      tooltipPosition="top"
    >
      Group Revert
    </button>
  </div>
  <p-table
    [value]="securityData"
    [paginator]="securityData.length > 0"
    [rows]="5"
    [tableStyle]="{ 'min-width': '50rem' }"
    dataKey="asReportedSecurityId"
    [(selection)]="selectedSecurities"
  >
    <ng-template #header>
      <tr>
        <th style="width: 4rem">
          <p-tableHeaderCheckbox />
        </th>
        <th>A R. ID</th>
        <th>Security Type</th>
        <th>Issuer Name</th>
          <th>URL</th>
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template #body let-security>
      <tr [pSelectableRow]="security">
        <td>
          <p-tableCheckbox [value]="security" />
        </td>
        <td>{{ security.asReportedSecurityId || "N/A" }}</td>

        <td>{{ security.asReportedSecurityType || "N/A" }}</td>
        <td>{{ security.asReportedIssuerName || "N/A" }}</td>
         <td>
          <a href="{{ security.xbrl }}" *ngIf="security.xbrl" target="_blank"
            >Link</a
          >
          <span *ngIf="!security.xbrl">-</span>
        </td>
        <td>
          <div>
            <button
              (click)="onRevertSecurity(security)"
              class="bg-red-600 text-white py-1 px-3 cursor-pointer rounded hover:bg-red-700 transition-colors"
            >
              Revert
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <ng-container *ngIf="noRecord">
    <div class="text-center py-6 text-gray-500">No record found</div>
  </ng-container>

  <div class="button-group flex justify-end py-3 space-x-2">
    <button
      class="bg-white hover:bg-gray-100 text-gray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
      (click)="onCancel()"
    >
      Cancel
    </button>
  </div>
  <p-confirmDialog></p-confirmDialog>
  <p-toast></p-toast>
</div>
